import type { MatomoEvent, MatomoSearchEvent } from '@/types/helper/matomo';
import { trackViaHTTPApi } from './http-api';

/**
 * Tracks a custom Matomo event.
 * @param event - MatomoEvent containing category, action, name, and value.
 * @returns Promise resolving to `true` if successful.
 */
export function trackEvent(event: MatomoEvent): Promise<boolean> {
  console.log('[Matomo helper] track event', event);
  const eventParams = [
    `e_c=${encodeURIComponent(event.e_c)}`,
    `e_a=${encodeURIComponent(event.e_a)}`,
    `e_n=${encodeURIComponent(event.e_n || '')}`,
    `e_v=${event.e_v}`,
  ];
  return trackViaHTTPApi(eventParams);
}

/**
 * Tracks a Matomo search event.
 * @param event - MatomoSearchEvent containing search term and result count.
 * @returns Promise resolving to `true` if successful.
 */
export function trackSearchEvent(event: MatomoSearchEvent): Promise<boolean> {
  console.log('[Matomo helper] track search event', event);
  const eventParams = [
    `search=${encodeURIComponent(event.search)}`,
    `search_count=${event.search_count}`,
  ];
  return trackViaHTTPApi(eventParams);
}
